import { FC, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import parseJwt from '../../../services/utils/parseJwt';
import MixPanelMessageBusAdapter, { buildMessageFromUserRole, MixPanelEventTypes } from '../../services/MixPanel';

const MixPanelProjectToken = import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN || '701b1855f9d4ad70a411574237605c59';

const MixPanelAggregator: FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { user } = useSelector((state: any) => state);
  const userId = useRef<number | null>(null);
  const mixPanelMessageBusAdapter = useRef<MixPanelMessageBusAdapter | null>(null);

  useEffect(() => {
    // TODO: make it an env variable
    const mixPanelDebug =
      (import.meta.env.VITE_MIXPANEL_DEBUG && import.meta.env.VITE_MIXPANEL_DEBUG == 'true') || false;

    mixpanel.init(MixPanelProjectToken, { debug: mixPanelDebug });
  }, []);

  useEffect(() => {
    if (
      userId.current !== user.currentUserId &&
      typeof user.currentUserId !== 'undefined' &&
      user.currentUserId !== null &&
      user.token !== null
    ) {
      const userData = parseJwt(user.token);
      mixpanel.identify(Number(user.currentUserId).toString());
      mixpanel.register({
        organization: userData.profile.organization,
        role: userData.profile.role,
        webSessionId: userData.profile.web_session_id,
      });
      const event = buildMessageFromUserRole(userData.profile.role, MixPanelEventTypes.CLICK, 'User Login');
      mixpanel.track(event.eventName(), event);
      mixPanelMessageBusAdapter.current = new MixPanelMessageBusAdapter();
    } else if (user.currentUserId === null) {
      mixPanelMessageBusAdapter.current?.unsubscribe();
    }
    userId.current = user.currentUserId;
  }, [user.currentUserId]);

  return <></>;
};

export default MixPanelAggregator;
